import React from 'react'

export default function ErrorMessage({ text }) {
  if (!text) return null

  return <div className="text-xs mt-1 mb-2 text-red-500">{text}</div>
}
